// USER
export const REQUEST_USER_DETAILS = "REQUEST_USER_DETAILS";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const REMOVE_USER_DETAILS = "REMOVE_USER_DETAILS";
export const REVOKE_USER_DETAILS = "REVOKE_USER_DETAILS";

export const REQUEST_USER_COMPANIES = "REQUEST_USER_COMPANIES";
export const REVOKE_USER_COMPANIES = "REVOKE_USER_COMPANIES";
export const RESET_USER_COMPANIES = "RESET_USER_COMPANIES";
export const SET_USER_COMPANIES = "SET_USER_COMPANIES";

export const REQUEST_UPDATE_USER_INFO = "REQUEST_UPDATE_USER_INFO";
export const REVOKE_UPDATE_USER_INFO = "REVOKE_UPDATE_USER_INFO";
export const RESET_UPDATE_USER_INFO = "RESET_UPDATE_USER_INFO";
export const GRANT_UPDATE_USER_INFO = "GRANT_UPDATE_USER_INFO";

export const REQUEST_USER_FULL_NAME = "REQUEST_USER_FULL_NAME";
export const REVOKE_USER_FULL_NAME = "REVOKE_USER_FULL_NAME";
export const RESET_USER_FULL_NAME = "RESET_USER_FULL_NAME";
export const GRANT_USER_FULL_NAME = "GRANT_USER_FULL_NAME";

export const REQUEST_UPDATE_USER_GENERAL = "REQUEST_UPDATE_USER_GENERAL";
export const REVOKE_UPDATE_USER_GENERAL = "REVOKE_UPDATE_USER_GENERAL";
export const RESET_UPDATE_USER_GENERAL = "RESET_UPDATE_USER_GENERAL";
export const GRANT_UPDATE_USER_GENERAL = "GRANT_UPDATE_USER_GENERAL";

export const REQUEST_UPDATE_USER_PASSWORD = "REQUEST_UPDATE_USER_PASSWORD";
export const REVOKE_UPDATE_USER_PASSWORD = "REVOKE_UPDATE_USER_PASSWORD";
export const RESET_UPDATE_USER_PASSWORD = "RESET_UPDATE_USER_PASSWORD";
export const GRANT_UPDATE_USER_PASSWORD = "GRANT_UPDATE_USER_PASSWORD";

export const REQUEST_USER_LOGINS = "REQUEST_USER_LOGINS";
export const SET_USER_LOGINS = "SET_USER_LOGINS";
export const REMOVE_USER_LOGINS = "REMOVE_USER_LOGINS";
export const REVOKE_USER_LOGINS = "REVOKE_USER_LOGINS";

export const REQUEST_UPDATE_USER_IMAGE = "REQUEST_UPDATE_USER_IMAGE";
export const REVOKE_UPDATE_USER_IMAGE = "REVOKE_UPDATE_USER_IMAGE";
export const RESET_UPDATE_USER_IMAGE = "RESET_UPDATE_USER_IMAGE";
export const GRANT_UPDATE_USER_IMAGE = "GRANT_UPDATE_USER_IMAGE";

export const REQUEST_DELETE_USER_IMAGE = "REQUEST_DELETE_USER_IMAGE";
export const REVOKE_DELETE_USER_IMAGE = "REVOKE_DELETE_USER_IMAGE";
export const RESET_DELETE_USER_IMAGE = "RESET_DELETE_USER_IMAGE";
export const GRANT_DELETE_USER_IMAGE = "GRANT_DELETE_USER_IMAGE";

export const REQUEST_USER_IMAGE = "REQUEST_USER_IMAGE";
export const REVOKE_USER_IMAGE = "REVOKE_USER_IMAGE";
export const RESET_USER_IMAGE = "RESET_USER_IMAGE";
export const GRANT_USER_IMAGE = "GRANT_USER_IMAGE";

//NOTIFICATIONS

export const REQUEST_ACCEPT_INVITATION = "REQUEST_ACCEPT_INVITATION";
export const GRANT_ACCEPT_INVITATION = "GRANT_ACCEPT_INVITATION";
export const REVOKE_ACCEPT_INVITATION = "REVOKE_ACCEPT_INVITATION";
export const RESET_ACCEPT_INVITATION = "RESET_ACCEPT_INVITATION";

export const REQUEST_REJECT_INVITATION = "REQUEST_REJECT_INVITATION";
export const GRANT_REJECT_INVITATION = "GRANT_REJECT_INVITATION";
export const REVOKE_REJECT_INVITATION = "REVOKE_REJECT_INVITATION";
export const RESET_REJECT_INVITATION = "RESET_REJECT_INVITATION";

export const REQUEST_UPDATE_UNSEEN_NOTIFICATIONS =
  "REQUEST_UPDATE_UNSEEN_NOTIFICATIONS";
export const GRANT_UPDATE_UNSEEN_NOTIFICATIONS =
  "GRANT_UPDATE_UNSEEN_NOTIFICATIONS";
export const REVOKE_UPDATE_UNSEEN_NOTIFICATIONS =
  "REVOKE_UPDATE_UNSEEN_NOTIFICATIONS";
export const RESET_UPDATE_UNSEEN_NOTIFICATIONS =
  "RESET_UPDATE_UNSEEN_NOTIFICATIONS";

export const REQUEST_FETCH_NOTIFICATIONS = "REQUEST_FETCH_NOTIFICATIONS";
export const GRANT_FETCH_NOTIFICATIONS = "GRANT_FETCH_NOTIFICATIONS";
export const REVOKE_FETCH_NOTIFICATIONS = "REVOKE_FETCH_NOTIFICATIONS";
export const RESET_FETCH_NOTIFICATIONS = "RESET_FETCH_NOTIFICATIONS";

//NAVIGATION
export const SET_ACTIVE_NAV_PAGE = "SET_ACTIVE_NAV_PAGE";
export const SET_ACTIVE_CHILD_NAV_PAGE = "SET_ACTIVE_CHILD_NAV_PAGE";
export const SET_ACTIVE_COMPANY = "SET_ACTIVE_COMPANY";
export const UPDATE_ACTIVE_COMPANY_NAME = "UPDATE_ACTIVE_COMPANY_NAME";

export const HIDE_NO_COMPANY_POPUP = "HIDE_NO_COMPANY_POPUP";

//SIGN OUT
export const USER_SIGNOUT = "USER_SIGNOUT";

export const REQUEST_COMPANY_OVERVIEW = "REQUEST_COMPANY_OVERVIEW";
export const SET_COMPANY_OVERVIEW = "SET_COMPANY_OVERVIEW";
export const REVOKE_COMPANY_OVERVIEW = "REMOVE_COMPANY_OVERVIEW";
